import React from 'react';
import PropTypes from 'prop-types';
import stringUtils from '../../../../qti/utils/StringUtils';

const RadioButton = (props) => {
    const {
        checked,
        columnChoiceIdentifier,
        handleUserResponse,
        isInverted,
        isReadOnly,
        modelIdentifier,
        rowChoiceIdentifier,
        questionId,
    } = props;

    const instanceId = stringUtils.getUID();
    const nameIdentifier = isInverted ? columnChoiceIdentifier : rowChoiceIdentifier;
    const name = `${nameIdentifier}-${modelIdentifier}-${questionId}`;
    const id = `${name}-${instanceId}`;
    const value = `${rowChoiceIdentifier} ${columnChoiceIdentifier}`;
    const labelledby = `rowChoice_${rowChoiceIdentifier} columnChoice_${columnChoiceIdentifier}`;

    return (
        <label htmlFor={id}>
            <input
                aria-labelledby={labelledby}
                checked={checked}
                disabled={isReadOnly}
                id={id}
                name={name}
                onChange={handleUserResponse}
                type="radio"
                value={value}
            />
        </label>
    );
};

RadioButton.propTypes = {
    checked: PropTypes.bool.isRequired,
    columnChoiceIdentifier: PropTypes.string.isRequired,
    handleUserResponse: PropTypes.func.isRequired,
    isInverted: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool,
    modelIdentifier: PropTypes.string.isRequired,
    rowChoiceIdentifier: PropTypes.string.isRequired,
    questionId: PropTypes.number.isRequired,
};

export default RadioButton;
